import { Divider } from "@components"
import { Input, Select, SelectItem, Textarea } from "@heroui/react"
import { PropTypes } from "prop-types"

const AppForm = ({ form, handleUpdateForm, types }) => (
  <div className="flex flex-col gap-y-4">
    <Input 
      label="Notification Title (Max 30 characters)"
      labelPlacement="outside"
      placeholder="Enter your notification title" 
      type="text" 
      isRequired
      maxLength={30}
      minLength={3}
      value={form.title}
      onValueChange={(value) => handleUpdateForm("title", value)}
    />

    <Divider />

    <Textarea
      label="Notification Text (Max 100 characters)"
      labelPlacement="outside"
      isRequired
      minRows={2}
      minLength={10}
      maxLength={100}
      placeholder="Enter you notification text"
      value={form.description}
      onValueChange={(value) => handleUpdateForm("description", value)}
    />

    <Divider />

    <Select
      label="Alert Type"
      labelPlacement="outside"
      isRequired
      selectedKeys={form.alertType ? [form.alertType.id] : []}
      onSelectionChange={(selection) => handleUpdateForm("alertType", types.find(type => type.id === selection.currentKey))}
      placeholder='Select an alert type'
    >
      {types.map((type) => (
        <SelectItem key={type.id} value={type.id}>
          {type.name}
        </SelectItem>
      ))}
    </Select>
  </div>
)

AppForm.propTypes = {
  form: PropTypes.shape({
    alertType: PropTypes.object,
    description: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  handleUpdateForm: PropTypes.func.isRequired,
  types: PropTypes.array.isRequired,
}

export default AppForm